import React from 'react';
import {
  ContextMenu,
  ContextMenuContent,
  ContextMenuItem,
  ContextMenuSeparator,
  ContextMenuTrigger,
} from '@/components/ui/context-menu';
import { Copy, Scissors, Clipboard, Trash2, CopyPlus, ArrowUp, ArrowDown, ChevronsUp, ChevronsDown } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface AbsoluteElementContextMenuProps {
  children: React.ReactNode;
  onCut: () => void;
  onCopy: () => void;
  onPaste: () => void;
  onDelete: () => void;
  onDuplicate: () => void;
  onBringToFront: () => void;
  onSendToBack: () => void;
  onBringForward: () => void;
  onSendBackward: () => void;
  canPaste?: boolean;
}

export function AbsoluteElementContextMenu({
  children,
  onCut,
  onCopy,
  onPaste,
  onDelete,
  onDuplicate,
  onBringToFront,
  onSendToBack,
  onBringForward,
  onSendBackward,
  canPaste = false,
}: AbsoluteElementContextMenuProps) {
  const { t } = useTranslation();
  
  const handleAction = (action: () => void) => (e: Event) => {
    e.stopPropagation();
    e.preventDefault();
    action();
  };

  return (
    <ContextMenu>
      <ContextMenuTrigger asChild>
        {children}
      </ContextMenuTrigger>
      <ContextMenuContent className="w-56">
        <ContextMenuItem onSelect={handleAction(onCut)}>
          <Scissors className="mr-2 h-4 w-4" />
          {t('invoiceTemplate.contextMenu.cut')}
        </ContextMenuItem>
        <ContextMenuItem onSelect={handleAction(onCopy)}>
          <Copy className="mr-2 h-4 w-4" />
          {t('invoiceTemplate.contextMenu.copy')}
        </ContextMenuItem>
        <ContextMenuItem onSelect={handleAction(onPaste)} disabled={!canPaste}>
          <Clipboard className="mr-2 h-4 w-4" />
          {t('invoiceTemplate.contextMenu.paste')}
        </ContextMenuItem>
        <ContextMenuItem onSelect={handleAction(onDuplicate)}>
          <CopyPlus className="mr-2 h-4 w-4" />
          {t('invoiceTemplate.contextMenu.duplicate')}
        </ContextMenuItem>
        
        <ContextMenuSeparator />
        
        <ContextMenuItem onSelect={handleAction(onBringToFront)}>
          <ChevronsUp className="mr-2 h-4 w-4" />
          {t('invoiceTemplate.contextMenu.bringToFront')}
        </ContextMenuItem>
        <ContextMenuItem onSelect={handleAction(onBringForward)}>
          <ArrowUp className="mr-2 h-4 w-4" />
          {t('invoiceTemplate.contextMenu.bringForward')}
        </ContextMenuItem>
        <ContextMenuItem onSelect={handleAction(onSendBackward)}>
          <ArrowDown className="mr-2 h-4 w-4" />
          {t('invoiceTemplate.contextMenu.sendBackward')}
        </ContextMenuItem>
        <ContextMenuItem onSelect={handleAction(onSendToBack)}>
          <ChevronsDown className="mr-2 h-4 w-4" />
          {t('invoiceTemplate.contextMenu.sendToBack')}
        </ContextMenuItem>
        
        <ContextMenuSeparator />
        
        <ContextMenuItem onSelect={handleAction(onDelete)} className="text-red-600">
          <Trash2 className="mr-2 h-4 w-4" />
          {t('invoiceTemplate.contextMenu.delete')}
        </ContextMenuItem>
      </ContextMenuContent>
    </ContextMenu>
  );
}
